let API_URL = import.meta.env.VITE_API_URL;
let headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};

if (localStorage.getItem("lang") !== null) {
    headers['Accept-Language'] = localStorage.getItem("lang");
}

export const setLanguage = (lang) => {
    headers['Accept-Language'] = lang;
}

export const getUrl = () => {
    return API_URL;
}

export const getHeaders = () => {
    return headers;
}

export const createObjection = (key, reason) => {
    return call('auth/objection', 'POST', {
        key: key,
        reason: reason
    })
        .then(data => {
            return data;
        })
        .catch((error) => {
            throw error;
        });
}

export const getObjections = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        `objection?paginate=${pagesize}&page=${page}`,
        'POST',
        { filter: filters }
    );
}

export const declineObjection = (objection_id) => {
    return call(`objection/${objection_id}`, 'DELETE')
}

export const acceptObjection = (objection_id) => {
    return call(`objection/${objection_id}/accept`, 'POST')
}

export const getAllBetaFeatures = () => {
    return call('all-beta-features', 'GET')
}

export const updateBetaFeatures = (beta_features) => {
    return call('all-beta-features', 'PUT', { features: beta_features })
        .then(data => {
            return data
        })
        .catch((error) => {
            console.log(error)
        });
}

export const register = (first_name, last_name, email, password, conditions, invitation_token, recaptcha_token, is_dancer = false, is_professional = false, newsletter_optin = false) => {
    return call('auth/register', 'POST', {
        first_name: first_name,
        last_name: last_name,
        email: email,
        password: password,
        conditions: conditions,
        invitation_token: invitation_token,
        is_dancer: is_dancer,
        is_professional: is_professional,
        newsletter_optin: newsletter_optin,
        'g-recaptcha-response': recaptcha_token
    })
    .then(data => {
        return data
    })
    .catch((error) => {
        console.log(error)
    });
}


export const login = (email, password) => {
    return call('auth/login', 'POST', {
        email: email,
        password: password
    })
    .then(data => {
        return data
    });
}

export const logout = () => {
    return call('auth/logout', 'POST');
}

export const isLoggedIn = () => {
    return localStorage.getItem('token') !== null;
}

export const checkAuth = () => {
    if (isLoggedIn()) {
        headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    } else {
        delete headers['Authorization'];
    }
}

export const verify = (id, hash) => {
    return call('auth/verify', 'POST', {
        id: id,
        hash: hash
    });
}

export const getTransferlinks = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(`transferlinks/search?paginate=${pagesize}&page=${page}`, 'POST', { filter: filters })
}

export const deleteTransferlink = (transferlink_id) => {
    return call(`transferlinks/${transferlink_id}`, 'DELETE');
}

export const validatetransferlink = (organizationSlug, key) => {
    return call(`organizations/${organizationSlug}/validateTransferlink`, 'POST', { key: key});
}

export const transferlinkAccept = (organizationSlug, key) => {
    return call(`organizations/${organizationSlug}/transferlink/accept`, 'POST', { key: key})
}

export function checkExistsEvent(organizationSlug, eventData) {
    return call(`organizations/${organizationSlug}/check-exists/event`, 'POST', eventData);
}

export const getStats = () => {
    return call('stats', 'GET');
}

export const getEvents = ({
    organizationSlug = null, page = 1, pagesize = 8, filters = [], mode = null, collapseMultiday = false
} = {}) => {
    const collapseParam = collapseMultiday ? '&collapse_multiday=1' : '';
    if (organizationSlug) {
        return call(
            'organizations/' + organizationSlug + '/event_overview' +
                '?paginate=' + pagesize + '&page=' + page + (mode ? '&mode=' + mode : '') + collapseParam,
            'POST',
            { filter: filters }
        );
    } else {
        return call(
            'events/search' +
                '?paginate=' + pagesize + '&page=' + page + (mode ? '&mode=' + mode : '') + collapseParam,
            'POST',
            { filter: filters }
        );
    }
}
export const searchEventsAndOrganizations = (query) => {
    return call(
        'search?query=' + query,
        'GET',
    );
};

export const getNearbyEvents = (filters = [], range = 1, amount = 5) => {
    return call('events/nearby', 'POST', {
        filter: filters,
        range: range,
        limit: amount,
    });
}

export const getManageableEvents = ({
    organization = null,
    page = 1,
    pagesize = 8,
    date_filter = null,
    ambassador_only = null,
    search = null
}) => {
    let url = 'manageable/events?paginate=' + pagesize + '&page=' + page;
    if (organization !== null)
        url += '&organization=' + encodeURIComponent(organization);
    if (date_filter !== null)
        url += '&date_filter=' + encodeURIComponent(date_filter);
    if (ambassador_only !== null)
        url += '&ambassador_only=' + encodeURIComponent(ambassador_only);
    if (search !== null && search !== '')
        url += '&search=' + encodeURIComponent(search);

    return call(url, 'GET');
}

export const getOrganizations = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'organizations/search?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}

export const getNearbyOrganizations = (filters = [], range = 1, amount = 5) => {
    return call('organizations/nearby', 'POST', {
        filter: filters,
        range: range,
        limit: amount,
    });
}

export const removeOrganization = (organizationSlug) => {
    return call('organizations/' + organizationSlug, 'DELETE');
}

export const removeEvent = (eventId) => {
    return call('events/' + eventId, 'DELETE');
}

export const removeImage = (image, origin) => {
    const data = {
        origin: origin
    };
    return call(
        'media/remove/image/' + image,
        'DELETE',
        data
    );
}

export const removeTicketType = (eventId, ticketTypeId) => {
    return call(`events/${eventId}/tickets/ticket_types/${ticketTypeId}`, 'DELETE');
};
export const createTicketType = (eventId, ticketTypeData) => {
    return call(`events/${eventId}/tickets/ticket_types`, 'POST', ticketTypeData)
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.log("Error creating ticket type:", error);
            throw error;
        });
};
export const updateTicketType = (eventId, TicketTypeId, ticketTypeData) => {
    return call(`events/${eventId}/tickets/ticket_types/${TicketTypeId}`, 'PUT', ticketTypeData)
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.log("Error updating ticket type:", error);
            throw error;
        });
};
export const getTicketType = (eventId,ticketTypeId) => {
    return call(`events/${eventId}/tickets/ticket_types/${ticketTypeId}`, 'GET');
}
export const getallTicketTypes = (eventId, { page = 1, pagesize = 8 } = {}) => {
    return call(
        `events/${eventId}/tickets/ticket_types?paginate=` + pagesize + '&page=' + page,
        'GET'
    );
}
export const getEvent = (eventSlug) => {
    return call('events/' + eventSlug, 'GET');
}

export const getOrganization = (organizationSlug) => {
    return call('organizations/' + organizationSlug, 'GET');
}

export const getManagableOrganization = (organizationSlug) => {
    return call('organizations/manage/' + organizationSlug, 'GET');
}
export const getManageableOrganizationsPaginated = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'organizations/manageable?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}
export const getManageableBrandsPaginated = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'organizations/manageable_brands?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}
export const getManageableOrganizations = (filters = []) => {
    return call("organizations/manageable", "POST", {
        filter: filters
    });
}

export const getOwnedOrganizations = () => {
    return call("organizations/owned", "POST");
}

export const storeForm = (form) => {
    return call('forms', 'POST', form);
}

export const getAllFormSubjects = () => {
    return call('form-subjects/all', 'GET');
}

export const storeOrganization = (organization) => {
    if (organization.slug) {
        return call('organizations/' + organization.slug, 'PUT', organization);
    }
    return call('organizations', 'POST', organization);
}

export const getAuthorizedPeople = ({ page = 1, pagesize = 8, filters = [] } = {}, organisation) => {
    return call(
        'organizations/' + organisation + '/authorized/overview?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}

export const getAuthorizedPerson = (organisation, user_id) => {
    return call(
        'organizations/' + organisation + '/authorized/' + user_id,
        'GET',
    );
}

export const storeAuthorizedPerson = (person) => {
    return call('organizations/' + person.organization_slug + '/authorized', 'POST', person);
}

export const removeAuthorizedPerson = (organisation, user_id) => {
    return call('organizations/' + organisation + '/authorized/' + user_id, 'DELETE');
}

export const getAuthorizedPeopleForManageableOrganizations = (page = 1, pagesize = 8, search = "") => {
    const url = `organizations/authorized/manageable?paginate=${pagesize}&page=${page}`
        + (search ? `&search=${search}` : "");

    return call(url, 'POST');
}

export const checkUserHasOwnedOrganizations = () => {
    return call('organizations/authorized/has-owned', 'GET');
}

export const getAmbassadors = () => {
    return call('ambassadors', 'GET');
}

export const getDanceStyles = ({ filters = null, type = 'event' } = {}) => {
    if (filters) {
        return call(
            'dance-styles',
            'POST',
            {
                filter: filters,
                type: type
            }
        );
    }
    return call('dance-styles', 'GET');
}

export const getDanceStylesWithoutSubDanceStyles = () => {
    return call(
        'dance-styles/overview',
        'POST',
    );
}

export const getDanceStylesPaginated = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    if (filters) {
        return call(
            'dance-styles/overview?paginate=' + pagesize + '&page=' + page,
            'POST',
            {
                filter: filters,
            }
        );
    }
    return call('dance-styles/overview?paginate=' + pagesize + '&page=' + page, 'POST');
}

export const getDanceStyle = (id) => {
    return call('dance-styles/' + id, 'GET');
}

export const storeDanceStyle = (dance_style) => {
    return call('dance-styles/store', 'POST', dance_style);
}

export const updateDanceStyle = (id, dance_style) => {
    return call('dance-styles/' + id, 'PUT', dance_style);
}

export const deleteDanceStyle = (id) => {
    return call('dance-styles/' + id, 'DELETE');
}

export const suggestDanceStyle = (dance_style) => {
    return call('dance-styles/suggest', 'POST', {dance_style: dance_style});
}

export const getMusicStyles = ({ filters = null, type = 'event' } = {}) => {
    if (filters) {
        return call(
            'music-styles',
            'POST',
            {
                filter: filters,
                type: type
            }
        );
    }
    return call('music-styles', 'GET');
}

export const getMusicStylesWithoutSubMusicStyles = () => {
    return call(
        'music-styles/overview',
        'POST',
    );
}

export const getMusicStylesPaginated = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    if (filters) {
        return call(
            'music-styles/overview?paginate=' + pagesize + '&page=' + page,
            'POST',
            {
                filter: filters,
            }
        );
    }
    return call('music-styles/overview?paginate=' + pagesize + '&page=' + page, 'POST');
}

export const getMusicStyle = (id) => {
    return call('music-styles/' + id, 'GET');
}

export const storeMusicStyle = (music_style) => {
    return call('music-styles/store', 'POST', music_style);
}

export const updateMusicStyle = (id, music_style) => {
    return call('music-styles/' + id, 'PUT', music_style);
}

export const deleteMusicStyle = (id) => {
    return call('music-styles/' + id, 'DELETE');
}

export const suggestMusicStyle = (music_style) => {
    return call('music-styles/suggest', 'POST', {music_style: music_style});
}

export const getCountries = () => {
    return call('countries', 'GET');
}

export const getAllCountries = () => {
    return call('countries/all', 'GET');
}

export const getAllCurrencies = () => {
    return call('currencies/all', 'GET');
}

export const getPagesPaginated = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'pages/overview?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}

export const getPage = (slug) => {
    return call('pages/' + slug, 'GET');
}

export const updatePage = (slug, page) => {
    return call('pages/' + slug, 'PUT', page);
}

export const getEventCategories = ({ filters = null } = {}) => {
    if (filters) {
        return call(
            'event/categories',
            'POST',
            { filter: filters }
        );
    }
    return call('event/categories', 'GET');
}

export const changeEventPublic = (event_slug, public_status) => {
    return call(`events/${event_slug}/change_public`, 'POST', { public: public_status })
}

export const inviteParticipant = ({ event = null, participant = null, role = null } = {}) => {
    return call('events/' + event + '/invite', 'POST', {
        name: participant,
        role: role
    });
}

export const getParticipants = (event) => {
    return call('events/' + event + '/participants', 'GET');
}

export const cancelInvite = (event, participant) => {
    return call('events/' + event + '/participants/' + participant + '/cancel', 'DELETE');
}

export const addParticipant = (event, organization) => {
    return call('events/' + event + '/participants/' + organization, 'POST');
}

export const removeParticipant = (event, organization) => {
    return call('events/' + event + '/participants/' + organization, 'DELETE');
}

export const getLanguages = () => {
    return call('languages', 'GET');
}

export const getTimezones = () => {
    return call('timezones', 'GET');
}

export const getMyFavorites = ({ mode = null, past = false, reverse = false }) => {
    mode = mode ? `/${mode}` : '';

    let query = [];
    query.push(`past=${past.toString()}`);
    query.push(`reverse=${reverse.toString()}`);

    query = query.length === 0 ? '' : `?${query.join('&')}`
    return call(`favorites${mode}${query}`, 'GET');
}

export const storeFavorite = (type, id, mode) => {
    return call('favorites', 'POST', {
        type: type,
        id: id,
        mode: mode
    });
}

export const storeSearch = (search) => {
    return call('user/search', 'POST', search);
}

export const getSearches = () => {
    return call('user/search', 'GET');
}

export const getSearch = (id) => {
    return call('user/search/' + id, 'GET');
}

export const removeSearch = (id) => {
    return call('user/search/' + id, 'DELETE');
}

export const report = (report) => {
    return call('report', 'POST', report);
}

export const getReportsOverview = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'reports/overview?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filters: filters }
    );
};

export const getReportByTypeAndId = ({ archived, type, id } = {}) => {
    return call(
        `reports/${archived}/${type}/${id}`,
        'GET'
    );
};

export const changeReportStatus = (reportId, status) => {
    return call(
        `reports/${reportId}/change-status`,
        'PUT',
        { status: status }
    )
};

export const archiveReport = (type, reportableId) => {
    return call(
        `reportable/${type}/${reportableId}/archive`,
        'PUT'
    )
}

export function toggleEventSuspension(slug) {
    return call(
        'events/' + slug + '/suspend',
        'PUT'
    )
};

export function toggleOrganizationSuspension(slug) {
    return call(
        'organizations/' + slug + '/suspend',
        'PUT'
    )
};

export const storeEvent = (organization, event) => {
    if (event.slug) {
        return call('organizations/' + organization + '/events/' + event.slug, 'PUT', event);
    }
    return call('organizations/' + organization + '/events', 'POST', event);
}

export const storeImpression = (type, id) => {
    return call('impressions', 'POST', {
        type: type,
        id: id
    });
}

/**
 * Records a "Buy tickets" click for an event (LA-153) and resolves with the
 * destination the browser should be sent to: { status, redirect_url }.
 * Takes the event slug (the Event route key), matching the other event routes.
 */
export const trackTicketClick = (eventSlug) => {
    return call('events/' + eventSlug + '/ticket-click', 'POST');
}

/** Ticket-click statistics for a brand (LA-153 phase 2). */
export const getOrganizationTicketStats = (organizationSlug) => {
    return call('organizations/' + organizationSlug + '/ticket-stats', 'GET');
}

/** Ticket-click statistics for a single event. */
export const getEventTicketStats = (eventSlug) => {
    return call('events/' + eventSlug + '/ticket-stats', 'GET');
}

/** Admin-only: opt a brand in/out of internal ("Type 2") ticketing. */
export const setOrganizationInternalTicketing = (organizationSlug, enabled) => {
    return call('organizations/' + organizationSlug + '/internal-ticketing', 'PUT', { enabled });
}

export const resendVerification = (email) => {
    return call('auth/resend-verification', 'POST', {
        email: email
    });
}

export const passwordForgotten = (email) => {
    return call('auth/password-forgotten', 'POST', {
        email: email
    });
}

export const passwordReset = (hash, email, password, password_repeat) => {
    return call('auth/password-reset', 'POST', {
        email: email,
        token: hash,
        password: password,
        password_repeat: password_repeat
    });
}

export const changePassword = (current, new_password, repeat) => {
    return call('auth/change-password', 'POST', {
        old_password: current,
        new_password: new_password,
        confirm_password: repeat
    });
}

export const deleteUser = () => {
    return call('auth/delete-account', 'DELETE');
}

export const updateSelf = (user) => {
    return call('auth/update', 'POST', user);
}

export const storeUserLinks = (links) => {
    return call('auth/update_links', 'POST', links);
}

export const uploadAvatar = (file) => {
    let formData = new FormData();
    formData.append('file', file);

    let uploadHeaders = JSON.parse(JSON.stringify(headers));
    delete uploadHeaders['Content-Type'];

    return fetch(API_URL + '/auth/avatar', {
        mode: 'cors',
        headers: uploadHeaders,
        method: 'POST',
        body: formData
    })
        .then((response) => response.json())
        .catch(function (error) {
            console.error('Request failed', error)
        });
}


export const sendVerificationText = (phone_number) => {
    return call('auth/send-verification-text', 'POST', {
        phone_number: phone_number
    });
}

export const initiateOrganizationTransfer = ({ organization, email, reason } = {}) => {
    return call('organizations/' + organization + '/transfer', 'POST', {
        email: email,
        reason: reason
    });
}

export const TransferRequest = ({ transferable_id, transferable_type, reason, to_organization_id = null } = {}) => {
    const payload = {
        reason: reason,
        transferable_id: transferable_id,
        transferable_type: transferable_type,
        ...(transferable_type === 'event' && { to_organization_id: to_organization_id })
    };

    return call('transfer-requests', 'POST', payload);
}

export const getTransfersPaginated = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'organizations/transfers?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}

export const getTransferRequests = ({ page = 1, pagesize = 8, filters = []} = {}) => {
    return call(
        'transfer-requests/overview?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}

export const approveTransferRequest = (id) => {
    return call('transfer-requests/' + id + '/approve', 'PUT');
}

export const rejectTransferRequest = (id) => {
    return call('transfer-requests/' + id + '/reject', 'PUT');
}

export const cancelTransfer = (id) => {
    return call('organizations/transfers/' + id, 'DELETE');
}

export const acceptTransfer = (id) => {
    return call('organizations/transfers/' + id + '/accept', 'POST');
}

export const rejectTransfer = (id) => {
    return call('organizations/transfers/' + id + '/reject', 'POST');
}

/* admin calls */
export const updateUser = (id, user) => {
    return call('users/' + id, 'PUT', user);
}

export const deleteUserById = (userId) => {
    return call('users/' + userId, 'DELETE');
}

export const getUser = (userId) => {
    return call('users/' + userId, 'GET');
}

export const changeUserPassword = (id, new_password) => {
    return call('users/' + id + '/change-password', 'POST', {
        new_password: new_password
    });
}

export const getUsers = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'users/overview?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}

export const getPermissions = () => {
    return call('permissions/overview', 'GET');
}

export const getRoles = () => {
    return call('roles/overview', 'GET');
}

export const getUserBlocks = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        `user_block?paginate=${pagesize}&page=${page}`,
        'POST',
        { filter: filters }
    );
}

export const getUserBlock = (user_block_id) => {
    return call(`user_block/${user_block_id}`, 'GET');
}

export const storeUserBlock = (user_block_id, form) => {
    if (user_block_id)
        return call(
            `user_block/${user_block_id}/`,
            'PUT',
            form
        );

    return call(
        `user_block/`,
        'PUT',
        form
    );
}

export const destroyUserBlock = (user_block_id) => {
    return call(`user_block/${user_block_id}`, 'DELETE')
}

export const getCarouselImages = () => {
    return call('carousel-images', 'GET');
}

export const getCarouselImagesPaginated = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'carousel-images/overview?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}

export const deleteCarouselImage = (image) => {
    return call('carousel-images/' + image.id, 'DELETE');
}

export const storeCarouselImage = (image) => {
    let formData = new FormData();
    formData.append('file', image.file);
    formData.append('visibility', image.visibility);
    formData.append('image_alt', image.image_title);
    formData.append('image_title', image.image_title);
    formData.append('order_by', image.order_by);
    formData.append('id', image.id);

    let uploadHeaders = JSON.parse(JSON.stringify(headers));
    delete uploadHeaders['Content-Type'];

    return fetch(API_URL + '/carousel-images', {
        mode: 'cors',
        headers: uploadHeaders,
        method: 'POST',
        body: formData
    })
        .then((response) => response.json())
        .catch(function (error) {
            console.error('Request failed', error)
        });
}

export const getCarouselImage = (id) => {
    return call('carousel-images/' + id, 'GET');
}

export const getSetting = (key) => {
    return call('setting/' + key, 'GET');
}

export const getAllSettings = () => {
    return call('settings/all', 'GET');
}

export const updateSetting = (setting) => {
    return call('settings/update', 'PUT', setting);
}

export const hardResetSettings = () => {
    return call('settings/hard_reset', 'PUT');
}

export const getInvites = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
        'invites/overview?paginate=' + pagesize + '&page=' + page,
        'POST',
        { filter: filters }
    );
}

export const sendInvite = ({ email = '', first_name = '', country = '', city = '', role = "3"} = {}) => {
    return call('invites', 'POST', {
        email: email,
        first_name: first_name,
        country: country,
        city: city,
        role: role,
    });
}

export const deleteInvite = (id) => {
    return call('invites/' + id, 'DELETE');
}

export const resendInvite = (id) => {
    return call('invites/' + id + '/resend', 'POST');
}

export const downloadExport = () => {
    return download('export/new', 'POST', 'out.csv', 'text/csv');
}

export const getScrapedConcepts = ({ page = 1, pagesize = 100, filters = [] } = {}) => {
    return call(
        `scraped-concepts/overview?paginate=${pagesize}&page=${page}`,
        'POST',
        { filter: filters }
    );
}

export const getScrapedConcept = (id) => {
    return call('scraped-concepts/' + id, 'GET');
}

export const updateScrapedConcept = (id, data) => {
    return call('scraped-concepts/' + id, 'PUT', data);
}

export const deleteScrapedConcept = (id) => {
    return call('scraped-concepts/' + id, 'DELETE');
}

export const assignConceptOrganization = (id, organizationId) => {
    return call('scraped-concepts/' + id + '/assign-organization', 'PUT', {
        organization_id: organizationId
    });
}

export const approveConcept = (id) => {
    return call('scraped-concepts/' + id + '/approve', 'POST');
}

export const rejectConcept = (id, adminNotes = null) => {
    return call('scraped-concepts/' + id + '/reject', 'PUT', {
        admin_notes: adminNotes
    });
}

export const triggerScrape = (source) => {
    return call('scraped-concepts/scrape', 'POST', { source: source });
}

export const cleanupPastConcepts = () => {
    return call('scraped-concepts/cleanup-past', 'DELETE');
}

/**
 * Run one action over a selection of concepts (LA-188).
 * action: 'approve' | 'reject' | 'assign'
 */
export const bulkConceptAction = (action, conceptIds, options = {}) => {
    return call('scraped-concepts/bulk', 'POST', {
        action,
        concept_ids: conceptIds,
        ...options,
    });
}

export const refreshConceptMatches = (conceptIds = null) => {
    return call(
        'scraped-concepts/refresh-matches',
        'POST',
        conceptIds ? { concept_ids: conceptIds } : {}
    );
}

export const triggerScrapeStream = async (source, forceUpdate, onProgress, onDone, onError) => {
    checkAuth();

    try {
        const response = await fetch(API_URL + '/scraped-concepts/scrape/stream', {
            mode: 'cors',
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ source: source, force_update: forceUpdate }),
        });

        if (!response.ok) {
            onError({ message: 'HTTP ' + response.status });
            return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n');
            buffer = lines.pop();

            let eventType = null;
            for (const line of lines) {
                if (line.startsWith('event: ')) {
                    eventType = line.slice(7).trim();
                } else if (line.startsWith('data: ') && eventType) {
                    const data = JSON.parse(line.slice(6));
                    if (eventType === 'progress') onProgress(data);
                    else if (eventType === 'done') onDone(data);
                    else if (eventType === 'error') onError(data);
                    eventType = null;
                }
            }
        }
    } catch (e) {
        onError({ message: e.message || 'Connection lost' });
    }
}

export const impersonateUser = (userId) => {
    return call('impersonate/' + userId, 'POST');
}

export const stopImpersonating = () => {
    return call('stop-impersonate', 'POST');
}

/* eof admin calls */

export const get = (path) => {
    return call(path, 'GET');
}

export const post = (path, data) => {
    return call(path, 'POST', data);
}

export const call = ( path, method, data = null) => {
    checkAuth();

    return fetch(API_URL + '/' + path, {
        mode: 'cors',
        headers: headers,
        method: method,
        body: method != 'GET' ? JSON.stringify(data) : null
    })
        .then((response) => response.json())
        .catch(function (error) {
            console.error('Request failed', error)
        });
}

export const download = ( path, method, filename, type = 'application/json', data = null) => {
    checkAuth();

    return fetch(API_URL + '/' + path, {
        mode: 'cors',
        headers: headers,
        method: method,
        body: method != 'GET' ? JSON.stringify(data) : null
    })
        .then((response) => response.text())
        .then((response) => {
            let blob = new Blob([response], { type: type });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        })
        .catch(function (error) {
            console.error('Request failed', error);
        });
}

export const storeLead = (lead) => {
    return call('leads', 'POST', lead);
}

/** Homepage Instagram strip (LA-179) — the API serves this from its own cache. */
export const getInstagramFeed = () => {
    return call('instagram/feed', 'GET');
}

/** Newsletter (LA-141) — fetches a short-lived anti-spam timing token. */
export const getNewsletterToken = () => {
    return call('newsletter/token', 'GET');
}

/** Newsletter sign-up (LA-141) — subscribes an email via Brevo.
 *  `token` is the anti-spam timing token; `companyWebsite` is the honeypot. */
export const subscribeNewsletter = (email, token = null, companyWebsite = '') => {
    return call('newsletter/subscribe', 'POST', {
        email,
        t: token,
        company_website: companyWebsite,
    });
}

export const getOrganizationTypes = () => {
    return call('organization-types', 'GET');
}

export const getEventStatuses = () => {
    return call('event-statuses', 'GET');
}

export const getLeads = ({ page = 1, pagesize = 8, filters = [] } = {}) => {
    return call(
            'leads/overview?paginate=' + pagesize + '&page=' + page,
            'POST',
            { filter: filters }
        );
}

export const getLead = (id) => {
    return call('leads/' + id, 'GET');
}

export const deleteLead = (id) => {
    return call('leads/' + id, 'DELETE');
}

export const checkEventPrice = ( slug, durationType, duration) => {
    return call(
        `events/${slug}/check`,
        'GET',
        { duration_type: durationType, duration: duration }
    );
};

export const buyFeaturedEvent = ( event, durationType, duration ) => {
    return call(
        `events/${event}/buy?duration_type=${durationType}&duration=${duration}`,
        'GET',
        { duration_type: durationType, duration: duration }
    );
};

export const getGlobalEventPrice = (durationType) => {
    return call(
        `events/price/global?duration_type=${durationType}`,
        'GET'
    );
};

export const updateGlobalEventPrice = ({ amount, durationType }) => {
    return call(
        `events/price/global`,
        'PUT',
        { amount: amount, duration_type: durationType }
    );
};

export const getFeaturedEvents = () => {
    return call(
        `events/featured`,
        'POST'
    );
};

export const getPaidPayments = ({ page = 1, paginate = 15 } = {}) => {
    return call(
        `payments/paid?page=${page}&paginate=${paginate}`,
        'POST'
    );
};

export const getPaymentStatus = (paynlTransactionId) => {
    return call(
        `payments/${paynlTransactionId}`,
        'GET'
    );
};

export const getPaymentInvoice = ( paynlTransactionId ) => {
    return call(
        `payments/${paynlTransactionId}/invoice`,
        'GET'
    );
};

export const checkoutShop = (data) => {
    return call(
        `ticket/shop`,
        'POST',
        data
    );
};

export const getPaymentStatusTickets = (paymentString) => {
    return call(
        `ticket/shop/payment/verify/${paymentString}`,
        'GET'
    );
};

export const getEventPrice = (eventSlug) => {
    return call(
        `api/events/${eventSlug}/priceOptions`,
        'GET'
    )
};

export const setEventFeatured = ({ eventSlug, durationType, duration }) => {
    return call(
        `events/${eventSlug}/set-featured`,
        'POST',
        { duration_type: durationType, duration }
    );
};

export const getEventPriceOptions = ( eventSlug ) => {
    return call(
        `events/${eventSlug}/priceOptions`,
        'GET',
    );
};

export const UpdateLeadStatus = ( id, status ) => {
    return call(
        `leads/${id}`,
        'PUT',
        { status: status }
    );
};
/* --- LA-194: submitting an event without an account ------------------------ */

/** Anti-spam timing token for the public submission form. */
export const getEventSubmissionToken = () => {
    return call('submit-event/token', 'GET');
};

/** Is this submission link usable, and whose brand is it for? */
export const resolveEventSubmissionLink = (code) => {
    return call(`submit-event/${code}`, 'GET');
};

/** Flattens a value into FormData entries the way Laravel reads them back:
 *  arrays as `key[0]`, `key[1]`… and plain objects (e.g. `links`) as
 *  `key[subkey]`, recursively. `null`/`undefined`/`''` are skipped so an empty
 *  optional field is simply absent rather than sent as the string "null". */
const appendToFormData = (formData, key, value) => {
    if (value === null || value === undefined || value === '') {
        return;
    }

    if (Array.isArray(value)) {
        value.forEach((entry, index) => appendToFormData(formData, `${key}[${index}]`, entry));
    } else if (value instanceof File || value instanceof Blob) {
        formData.append(key, value);
    } else if (typeof value === 'object') {
        Object.keys(value).forEach((subKey) => appendToFormData(formData, `${key}[${subKey}]`, value[subKey]));
    } else {
        formData.append(key, value);
    }
};

/** Send in an event. `t` is the timing token, `company_website` the honeypot,
 *  `photos` the files picked in the form (at least one is required). Always
 *  multipart — a file cannot ride along in JSON, and photos are no longer
 *  optional. */
export const submitEvent = (code, payload, photos = []) => {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => appendToFormData(formData, key, payload[key]));

    photos.forEach((photo, index) => formData.append(`photos[${index}]`, photo));

    // The browser has to set Content-Type itself: it carries the multipart
    // boundary, which we cannot know here.
    const uploadHeaders = JSON.parse(JSON.stringify(headers));
    delete uploadHeaders['Content-Type'];

    return fetch(`${API_URL}/submit-event/${code}`, {
        mode: 'cors',
        headers: uploadHeaders,
        method: 'POST',
        body: formData,
    })
        .then((response) => response.json())
        .catch(() => undefined);
};

/** Admin: the links organisers submit events through. */
export const getSubmissionLinks = (filters = {}, page = 1, paginate = 50) => {
    return call(`submission-links/overview?page=${page}&paginate=${paginate}`, 'POST', { filter: filters });
};

export const createSubmissionLink = (data) => {
    return call('submission-links', 'POST', data);
};

export const updateSubmissionLink = (id, data) => {
    return call(`submission-links/${id}`, 'PUT', data);
};

export const deleteSubmissionLink = (id) => {
    return call(`submission-links/${id}`, 'DELETE');
};

/* --- LA-157: automated email preferences ---------------------------------- */

/** Which address an unsubscribe link belongs to, and whether it still gets mail. */
export const getEmailPreferences = (token) => {
    return call(`email-preferences/${token}`, 'GET');
};

/** Stop LatinMap's automated emails to this address. POST, not GET: mail
 *  scanners follow links before a person ever sees them. */
export const unsubscribeEmails = (token) => {
    return call(`email-preferences/${token}/unsubscribe`, 'POST');
};

export const resubscribeEmails = (token) => {
    return call(`email-preferences/${token}/resubscribe`, 'POST');
};
